import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "position", "maxWidth", "minWidth", "maxHeight", "minHeight", "htmlTag", "css", "style", "shouldShrink", "shouldGrow", "gridSpans", "top", "right", "bottom", "left", "inset", "children"];
import React from "react";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import { BaseBox } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Box(_ref) {
  var width = _ref.width,
    height = _ref.height,
    position = _ref.position,
    maxWidth = _ref.maxWidth,
    minWidth = _ref.minWidth,
    maxHeight = _ref.maxHeight,
    minHeight = _ref.minHeight,
    htmlTag = _ref.htmlTag,
    css = _ref.css,
    style = _ref.style,
    _ref$shouldShrink = _ref.shouldShrink,
    shouldShrink = _ref$shouldShrink === void 0 ? true : _ref$shouldShrink,
    shouldGrow = _ref.shouldGrow,
    gridSpans = _ref.gridSpans,
    top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    left = _ref.left,
    inset = _ref.inset,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = gridSpans || EMPTY_OBJ,
    cols = _ref2.cols,
    rows = _ref2.rows;
  return /*#__PURE__*/_jsx(BaseBox, _extends({
    shouldShrink: shouldShrink,
    shouldGrow: shouldGrow,
    as: htmlTag,
    css: {
      width: width,
      height: height,
      position: position,
      maxWidth: maxWidth,
      minWidth: minWidth,
      maxHeight: maxHeight,
      minHeight: minHeight,
      gridColumn: cols,
      gridRow: rows,
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      inset: inset
    }
  }, restProps, {
    children: children
  }));
}
export default Box;